var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherWindSpeed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.222 5.074v23.279H2.778c-.43 0-.778.369-.778.823 0 .455.348.824.778.824h12.444c.43 0 .778-.369.778-.824s-.348-.823-.778-.823H9.778V5.073c.465-.284.778-.816.778-1.426C10.556 2.737 9.859 2 9 2s-1.556.737-1.556 1.647c0 .61.313 1.142.778 1.427"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.852 7.794 27.333 9.41v4.18l-11.482 1.628-5.604-3.382a.81.81 0 0 0-1.137.327c-.228.422-.09.96.31 1.201l5.833 3.52a.8.8 0 0 0 .524.108l12.5-1.76c.414-.058.723-.43.723-.872V8.64c0-.441-.31-.814-.723-.872l-12.5-1.76a.8.8 0 0 0-.56.132L9.382 10.1a.91.91 0 0 0-.25 1.216.807.807 0 0 0 1.151.264l5.568-3.786z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 14.176c0 .455.448.824 1 .824s1-.369 1-.824V8.824C24 8.369 23.552 8 23 8s-1 .369-1 .824zm-5 .967c0 .473.448.857 1 .857s1-.384 1-.857V7.857C19 7.384 18.552 7 18 7s-1 .384-1 .857z"
}))));
export default SvgWeatherWindSpeed;